module.exports = __webpack_public_path__ + "static/media/gear-animation-1.7a7e512d.svg";